'use client'

import { useTranslations } from 'next-intl'

import {
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog'
import { GradientButton } from '@/components/common/gradient-button'
import { popModal } from '@/components/modals'
import { useProjectStore } from '@/hooks/use-project-store'

export function SubscribeSuccessfulModal() {
  const t = useTranslations('pricing_v2.subscribe_successful_modal')
  const { project } = useProjectStore()

  const handleContinue = async () => {
    popModal()
  }

  return (
    <DialogContent
      className="w-[95%] max-w-[640px] sm:max-w-[640px] p-0 rounded-[20px] overflow-hidden bg-[#171B27] border-none"
      style={{
        boxShadow: '0px 0px 24px 0px rgba(21, 241, 253, 1)',
        backdropFilter: 'blur(134px)',
        WebkitBackdropFilter: 'blur(134px)',
        borderRadius: '20px',
      }}
    >
      <div className="relative w-full h-full">
        <div className="relative m-[1px] rounded-[20px] p-7 max-w-full overflow-hidden">
          <DialogHeader>
            <DialogTitle className="text-xl text-center">
              {t('title')}
            </DialogTitle>
            <DialogDescription className="hidden">...</DialogDescription>
          </DialogHeader>
          <div className="py-4">
            {t.rich('description', {
              projectName: () => (
                <span className="font-medium text-[#15F1FD]">
                  {project?.project_name || ''}
                </span>
              ),
              newLine: (chunks) => <span className="block mt-1">{chunks}</span>,
            })}
          </div>
          <div className="pt-4 flex justify-end sm:justify-end md:justify-end">
            <GradientButton
              onClick={handleContinue}
              className="w-full sm:w-auto"
            >
              {t('button')}
            </GradientButton>
          </div>
        </div>
      </div>
    </DialogContent>
  )
}
